// Standard word restrictions for designation / job-title fields.
//
// Kept in its own module (rather than Helper.js) so every form can pull the
// same rule without depending on the wider helper barrel.

// Standard word restrictions shared by every designation input in the app.
// Letters, spaces, hyphens, periods, apostrophes, parentheses, ampersands and
// slashes only - matching the name-like field convention used elsewhere.
export const DESIGNATION_MIN_LENGTH = 2;
export const DESIGNATION_MAX_LENGTH = 50;
export const DESIGNATION_ALLOWED_PATTERN = /^[a-zA-Z\s\-.'()&/]+$/;

export const validateDesignation = (value, label = "Designation") => {
  const sanitized = (value || "").trim().replace(/\s+/g, " ");

  if (sanitized === "") {
    return `${label} is required.`;
  }

  if (sanitized.length < DESIGNATION_MIN_LENGTH) {
    return `${label} must be at least ${DESIGNATION_MIN_LENGTH} characters long.`;
  }

  if (sanitized.length > DESIGNATION_MAX_LENGTH) {
    return `${label} must not exceed ${DESIGNATION_MAX_LENGTH} characters.`;
  }

  if (!DESIGNATION_ALLOWED_PATTERN.test(sanitized)) {
    return `${label} contains invalid characters.`;
  }

  return null;
};
